import BaseFormControlLabel from '@material-ui/core/FormControlLabel'

const FormControlLabel = BaseFormControlLabel

export default FormControlLabel
